var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto my-5",attrs:{"max-width":"800"}},[_c('about-details',{attrs:{"about":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }